export default "/splash.png";